import { SessionAdapter } from "@/domain/session-adapter";
import { IEventAggregationService } from '@studyportals/student-interfaces';

export class LoginStatusCheckerPlugin {
	public async getHandler(): Promise<void> {

		const eventAggregationService = window["EventAggregationService"];
		if (!eventAggregationService) {
			return;
		}

		const sessionAdapter = this.createSessionAdapter(eventAggregationService);

		await sessionAdapter.initialize();
	}

	private createSessionAdapter(eventAggregationService: IEventAggregationService): SessionAdapter {
		return new SessionAdapter(eventAggregationService);
	}
}